import React from 'react';

import FormItem from 'components/formik/FormItem';
import FormikFileUpload from 'components/formik/FormikFileUpload';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import { generateUploadFileList, getFileUploadMessages } from 'utils/fileUtils';
import adminApiClient from 'api/adminApiClient';
import backofficeApiClient, {
  ResourceDownloadResponse,
} from 'api/backofficeApiClient';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';

type Props = {
  defaultFile?: ResourceDownloadResponse;
  isAdmin?: boolean;
};

const FILE_TYPES = ['DOC', 'DOCS', 'PDF', 'RTF'];

const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

const uploadFilesLinkFunctionForAdmin =
  adminApiClient.getBankingInfoFileUploadLink.bind(adminApiClient);

const uploadFilesLinkFunction =
  backofficeApiClient.getBankingInfoFileUploadLink.bind(backofficeApiClient);

export default React.memo((props: Props) => {
  const { defaultFile, isAdmin } = props;
  const fileList = defaultFile ? generateUploadFileList(defaultFile) : [];

  return (
    <FormItem
      name="bankingFile"
      label="Please use this section to upload documentation for your bank that validates your ownership (e.g. Voided check or Direct Deposit)."
      data-id="uploadBankingInformationField"
      showValidateError={false}
    >
      <FormikFileUpload
        name="bankingFile"
        defaultFileList={fileList}
        isDraggable
        maxFileCount={1}
        acceptedFileSize={10}
        acceptedFileFormat={[
          '.doc',
          '.docx',
          '.pdf',
          '.rtf',
          'application/msword',
          'application/pdf',
          'application/rtf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ]}
        getUploadList={UploadList}
        messages={fileUploadMessages}
        uploadLinkFunction={
          isAdmin ? uploadFilesLinkFunctionForAdmin : uploadFilesLinkFunction
        }
      >
        {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
      </FormikFileUpload>
    </FormItem>
  );
});
